/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@app/config/i18n';
import Typography from '@app/components/atoms/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid, Switch, FormControlLabel } from '@mui/material';
import { useUser } from '@app/contexts/userContext';
import { useSubmissionForm } from '@app/hooks/useSubmissionForm';
import OpportunitySubmissionApplicationsViewer from '../OpportunitySubmissionApplicationsViewer';
import UserSubmissionApplicationsPage from './UserSubmissionApplicationsPage';
import SubmissionApplicationForm from './SubmissionApplicationForm';

const SubmissionsForm = ({
  opportunity,
  applicationSubmissionFilters,
}) => {
  const { isOrganiserOrInvitedAdmin } = useUser();
  const { t } = useTranslation(['common']);
  const [showApplicationForm, setShowApplicationForm] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const hasAdminAccess = isOrganiserOrInvitedAdmin(opportunity);

  const {
    columns,
    tableCols,
    handleToggleColumn,
    opportunitySubmissionForm,
    opportunitySubmissionFormLoading,
    toggleSubmissionFormVisibility,
    updatingSubmissionForm,
  } = useSubmissionForm({
    opportunity,
    isOrganizer: hasAdminAccess,
  });

  if (hasAdminAccess) {
    return (
      <>
        <Grid container justifyContent="flex-end" sx={{ mb: 2 }}>
          <FormControlLabel
            control={
              <Switch
                checked={opportunitySubmissionForm?.is_active}
                onChange={toggleSubmissionFormVisibility}
                color="primary"
                disabled={updatingSubmissionForm}
              />
            }
            label={
              opportunitySubmissionForm?.is_active
                ? t('common:Submissions Open')
                : t('common:Submissions Closed')
            }
            labelPlacement="start"
          />
        </Grid>
        <OpportunitySubmissionApplicationsViewer
          opportunity={opportunity}
          applicationSubmissionFilters={applicationSubmissionFilters}
          columns={columns}
          tableCols={tableCols}
          handleToggleColumn={handleToggleColumn}
        />
      </>
    );
  }

  if (opportunitySubmissionFormLoading) {
    return null;
  }

  if (opportunity.is_closed || opportunitySubmissionForm?.is_active === false) {
    return (
      <Typography
        style={{ marginTop: isMobile ? '3rem' : '6rem' }}
        align="center"
        variant="subtitle1"
        color="secondary"
      >
        {t('common:closed_event')}
      </Typography>
    );
  }
  if (showApplicationForm && opportunity) {
    return (
      <SubmissionApplicationForm
        opportunity={opportunity}
        showApplicationForm={showApplicationForm}
        setShowApplicationForm={setShowApplicationForm}
      />
    );
  }

  return (
    <UserSubmissionApplicationsPage
      opportunity={opportunity}
      showApplicationForm={showApplicationForm}
      setShowApplicationForm={setShowApplicationForm}
      opportunitySubmissionForm={opportunitySubmissionForm}
      columns={columns}
      tableCols={tableCols}
      handleToggleColumn={handleToggleColumn}
    />
  );
};

SubmissionsForm.propTypes = {
  opportunity: PropTypes.object,
  applicationSubmissionFilters: PropTypes.object,
};

SubmissionsForm.defaultProps = {
  opportunity: null,
  applicationSubmissionFilters: {},
};

export default SubmissionsForm;

